import { Injectable } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { Observable } from 'rxjs';

import { ModalWidowUsersComponent } from '../modal-edit-user/modal-edit-user.component';
import { DisplayAccountViewModel } from '../../core/models/view-models/account-models/user-models/display-account-view-model.type';
import { AppConstants } from '../../app.constants';

@Injectable({
  providedIn: 'root'
})
export class EditUserDialogService {

  constructor(public dialog: MatDialog) { }

  public show(user: DisplayAccountViewModel, allowEditAdminRole: boolean, isAdmin: boolean): Observable<void> {

    const dialogRef = this.dialog.open(ModalWidowUsersComponent, {
      width: AppConstants.MODAL_WINDOW_WIDTH
    });
    dialogRef.componentInstance.user = user;
    dialogRef.componentInstance.allowEditAdminRole = allowEditAdminRole;
    dialogRef.componentInstance.isAdmin = isAdmin;
    return dialogRef.afterClosed();
  }
}
